import React from 'react'

import Layout from '../../components/layouts/layout'
import { Helmet } from 'react-helmet'

const CalendarioLaboral = () => {
  const baseURL = process.env.GATSBY_BASE_URL_CDN + '/calendario-laboral/'
  const htmlCalendar =
    ` 
      
      <!DOCTYPE html>
<!--[if IE 9]><html class="no-js ie9"><![endif]-->
<!--[if gt IE 9]><!--><html class="no-js"><!--<![endif]-->
    <head><meta http-equiv="Content-Type" content="text/html; charset=gb18030">
        <!---->
        <!---->
        
        
        <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1"> 
        <meta name="viewport" content="width=device-width, initial-scale=1.0"> 
        <title>Calendario Laboral 2024</title>
        <link rel="stylesheet" href="` +
    baseURL +
    `css/font-awesome.min.css">
        <link rel="stylesheet" type="text/css" href="` +
    baseURL +
    `css/demo.css" />
        <link rel="stylesheet" type="text/css" href="` +
    baseURL +
    `css/calendar.css" />
        <link rel="stylesheet" type="text/css" href="` +
    baseURL +
    `css/custom_2.css" />
         <script type="text/javascript" src="` +
    baseURL +
    `js/jquery.min.js"></script>
         <script src="` +
    baseURL +
    `js/modernizr.custom.63321.js"></script>
          <script type="text/javascript" src="` +
    baseURL +
    `js/data.js"></script>
          <script type="text/javascript" src="` +
    baseURL +
    `js/jquery.calendario.js"></script>
        
        
	<!-- Google Tag Manager -->

	<!-- End Google Tag Manager -->
		
   </head>
    <body>
        <div class="container"> 


            <div class="container-calendar">

                <div class="left-container-calendar">
                    &nbsp;
                </div>

                <section class="main" style="padding-bottom: 20px;">
                    <div class="custom-calendar-wrap">
                        <div id="custom-inner" class="custom-inner">
                            <div class="custom-header clearfix">
                                <nav>
                                    <span id="custom-prev" class="custom-prev"></span>
                                    <span id="custom-next" class="custom-next"></span>
                                </nav>

                                <div class="title-calendar">
                                    <h2 class="custom-month">
                                        <span id="custom-month"></span>
                                        <span id="custom-year"></span>
                                    </h2>
                                    <!-- <h3 id="custom-year" class="custom-month"></h3> -->
                                </div>

                                <!-- <h2 id="custom-month" class="custom-month"></h2>
                                <h3 id="custom-year" class="custom-year"></h3> -->
                            </div>
                            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                            <tr bgcolor="#f6f6f6">
                            <td align="center" style="padding-left:10px; padding-top:3px; padding-bottom:3px;">                            
                                &nbsp;
                            </td>
                            <td style="padding-top:3px; padding-bottom:3px;">
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <span style='display:inline-block;margin-right: 6px;vertical-align: middle;'>
                                    <div class="circulo"></div>
                                </span>
                                <span style="color:#666666; font-size:14px;vertical-align: middle;">Obligaciones laborales</span>
                            </td>
                            <td align="center" style="padding-left:10px; padding-top:3px; padding-bottom:3px;"><div class="cuadrado"></div></td>
                            <td style="padding-top:3px; padding-bottom:3px;"><span style="color:#666666; font-size:14px;">Feriados</span></td>
                            </tr>
                            </table>
                            <div id="calendar" class="fc-calendar-container"></div>
                        </div>
                    </div>
                </section>

                <div class="right-container-calendar">
                    <div class="icon-alert">
                        <img src="` +
    baseURL +
    `images/boton-de-informacion.png" alt="boton informacion">
                    </div>
                    <div class="aviso">
                        <h3><b>Calendario de Vencimientos Tributario - Laborales</b></h3>
                        <div class="body">
                            <ul>
                                <li>Sistema Privado de Pensiones</li>
                                <li>Derechos y obligaciones laborales</li>
                                <li>Presentaci&oacute;n de la planilla electr&oacute;nica - vencimientos Sunat</li>
                                <li>Impuesto a la Renta</li>
                            </ul>
                        </div>
                    </div>

                </div>

            </div>
        </div>
        <!-- /container -->
        
    </body>
    <script type="text/javascript" src="` +
    baseURL +
    `js/script.js"></script>
</html>
      
      `

  return (
    <Layout>
      <h1 className="center c-orange-0 mt-6 mb-4">Calendario Laboral 2024</h1>
      <Helmet>
        <title>Calendario Laboral | Prima AFP</title>
        <meta name='title' content='Calendario Laboral | Prima AFP' data-react-helmet="true" />
        <meta name='description' content='Prima AFP te cuenta que dias del año hay feriados. Con el calendario laboral de prima enterate de los feriados del 2024.' data-react-helmet="true" />
        <script
          type="text/javascript"
          src={baseURL + 'js/jquery.min.js'}
        ></script>
        <script src={baseURL + 'js/modernizr.custom.63321.js'}></script>
        <script
          type="text/javascript"
          src={baseURL + 'js/data.js'}
        ></script>
        <script
          type="text/javascript"
          src={baseURL + 'js/jquery.calendario.js'}
        ></script>
      </Helmet>
      <div
        dangerouslySetInnerHTML={{
          __html: htmlCalendar,
        }}
      />

      <Helmet>
        <script
          type="text/javascript"
          src={baseURL + 'js/script.js'}
        ></script>
      </Helmet>
    </Layout>
  )
}

export default CalendarioLaboral
